function array_remove(hystack, needle) {
	hystack.forEach((item, index) => {
		if (item === needle)
			hystack.splice(index, 1);
	});
}

export default class RequestQueue {
	constructor(store) {
		this.$store = store;
		this.pool = new Array();
		this.edge = Promise.resolve(null);
	}

	clear() {
		this.pool = new Array();
	}

	enqueue(request) {
		const on_loop = (prev) => {
			if (prev)
				array_remove(this.pool, prev);
			let req = this.pool[0];
			if (req) {
				return req.toPromise();
			}
			return Promise.resolve(null);
		};
		if(request){
			request.reset();
			this.pool.push(request);
		}
		this.edge = this.edge.then(on_loop);
	}

	abort(id) {
		return this.pool.some((item) => {
			if (item.isUnProcessing && item.request_id === id) {
				item.abort();
				return true;
			}
			return false;
		});
	}
}
